import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { AccommodationProductType } from '@libs/trip-planner-interfaces';
import {
  AccommodationType,
  AmenitiesFilter,
  BoardBasisCode,
} from '@libs/trip-planner-interfaces';
import { exhaustiveGuard } from '@libs/utils';

const { t } = i18n.global;

export function getBoardBasisText(boardBasis: BoardBasisCode): string {
  switch (boardBasis) {
    case BoardBasisCode.RoomOnly:
      return t('filter.boardBasis.no_meals');
    case BoardBasisCode.Breakfast:
      return t('filter.boardBasis.included_breakfast');
    case BoardBasisCode.HalfBoard:
      return t('filter.boardBasis.included_half_board');
    case BoardBasisCode['HalfBoardPlus']:
      return t('filter.boardBasis.included_half_board_plus');
    case BoardBasisCode.FullBoard:
      return t('filter.boardBasis.included_full_board');
    case BoardBasisCode.AlInclusive:
      return t('filter.boardBasis.all_inclusive');
    default:
      exhaustiveGuard(boardBasis, 'the board basis code is not defined');
  }
}

export function getBoardBasisTextNoIncluded(
  boardBasis: BoardBasisCode
): string {
  switch (boardBasis) {
    case BoardBasisCode.RoomOnly:
      return t('filter.boardBasis.no_meals');
    case BoardBasisCode.Breakfast:
      return t('filter.boardBasis.breakfast');
    case BoardBasisCode.HalfBoard:
      return t('filter.boardBasis.half_board');
    case BoardBasisCode['HalfBoardPlus']:
      return t('filter.boardBasis.half_board_plus');
    case BoardBasisCode.FullBoard:
      return t('filter.boardBasis.full_board');
    case BoardBasisCode.AlInclusive:
      return t('filter.boardBasis.all_inclusive');
    default:
      exhaustiveGuard(boardBasis, 'the board basis code is not defined');
  }
}

export function getAmenitiesText(amenity: AmenitiesFilter): string {
  switch (amenity) {
    case AmenitiesFilter.AirConditioned:
      return t('filter.amenities.air_conditioned');
    case AmenitiesFilter.Gym:
      return t('filter.amenities.gym');
    case AmenitiesFilter.Parking:
      return t('filter.amenities.parking');
    case AmenitiesFilter.Pool:
      return t('filter.amenities.pool');
    case AmenitiesFilter.Spa:
      return t('filter.amenities.spa');
    case AmenitiesFilter.VehicleChargingStation:
      return t('filter.amenities.electric_vehicle_charging_station');
    case AmenitiesFilter.Wifi:
      return t('filter.amenities.wifi');
    default:
      exhaustiveGuard(amenity, 'the amenity is not defined');
  }
}

export function getAccommodationTypeText(
  accommodationType: AccommodationProductType
): string {
  switch (accommodationType) {
    case AccommodationType.Hotel:
      return t('filter.hotelTypes.hotels');
    case AccommodationType.Apartment:
      return t('filter.hotelTypes.apartments');
    case AccommodationType.HouseOrCottage:
      return t('filter.hotelTypes.housesAndCottages');
    default:
      exhaustiveGuard(
        accommodationType,
        'the accommodation type is not defined'
      );
  }
}
